// Categories types
export const FETCH_PLATFORMS_START = "FETCH_PLATFORMS_START";
export const FETCH_PLATFORMS_SUCCESS = "FETCH_PLATFORMS_SUCCESS";
export const FETCH_PLATFORMS_ERROR = "FETCH_PLATFORMS_ERROR";

// Single category types
export const CREATE_PLATFORM_START = "CREATE_PLATFORM_START";
export const CREATE_PLATFORM_SUCCESS = "CREATE_PLATFORM_SUCCESS";
export const CREATE_PLATFORM_ERROR = "CREATE_PLATFORM_ERROR";
export const DELETE_PLATFORM_START = "DELETE_PLATFORM_START";
export const DELETE_PLATFORM_SUCCESS = "DELETE_PLATFORM_SUCCESS";
export const DELETE_PLATFORM_ERROR = "DELETE_PLATFORM_ERROR";
export const UPDATE_PLATFORM_START = "UPDATE_PLATFORM_START";
export const UPDATE_PLATFORM_SUCCESS = "UPDATE_PLATFORM_SUCCESS";
export const UPDATE_PLATFORM_ERROR = "UPDATE_PLATFORM_ERROR";
